"use client";

import React, { useEffect, useState } from "react";
import SeoLink from "./seoLink";
import styles from "./SeoLink.module.css";

interface SeoLinksSectionProps {
  className?: string;
}

interface LandingJob {
  id: number;
  title: string;
  slug: string;
  job_title: string;
}

const SeoLinksSection: React.FC<SeoLinksSectionProps> = ({ className = "" }) => {
  const [landingJobs, setLandingJobs] = useState<LandingJob[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchJobs = async () => {
      try {
        const response = await fetch('/api/landing-jobs');
        const data = await response.json();
        setLandingJobs(data.landingJobs || []);
      } catch (error) {
        console.error('Failed to fetch landing jobs for footer:', error);
        setLandingJobs([]);
      } finally {
        setLoading(false);
      }
    };

    fetchJobs();
  }, []);

  if (loading) {
    return (
      <div className={className}>
        <div className={styles.row}>
          <div key="skeleton-1" className={`${styles.skeleton} ${styles.skeleton1}`}></div>
          <div key="skeleton-2" className={`${styles.skeleton} ${styles.skeleton2}`}></div>
        </div>
      </div>
    );
  }

  if (landingJobs.length === 0) {
    return null;
  }

  return (
    <div className={className}>
      <div className={styles.row}>
        {landingJobs.map((job) => (
          <SeoLink
            key={job.id}
            title={job.title}
            slug={job.slug}
            job_title={job.job_title}
          />
        ))}
      </div>
    </div>
  );
};

export default SeoLinksSection;
